import { LIGHT_THREE_TEXTURE_KEYS } from '.'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/light-three/`

  if (!scene.textures.getTextureKeys().includes(LIGHT_THREE_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      LIGHT_THREE_TEXTURE_KEYS.ATLAS,
      `${prefix}animation-light-three-images.json`,
      `${prefix}atlases/`,
    )
  }
}
